import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
const queryString = require('query-string');

class TemplateCarouselBasicCenter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image: "",
            error: false
        };
    };

    componentWillMount() {
        try {
            let url = window.location.search;
            let data = queryString.parse(url);
            this.setState({
                image: data.image,
            }, () => {
                console.log(this.state.image)
            })
        }catch (e) {
            this.setState({
                error: true
            });
        }
    }

    render() {
        return(
            <div style={{backgroundImage: 'url('+this.state.image+')'}} className={Styles.container}/>
        )
    }
}

export default TemplateCarouselBasicCenter;


// WEBPACK FOOTER //
// ./src/templates/carousel/basic/center/component.js